import styled from 'styled-components'
import { font, bp } from 'lib/core/resources/helpers/styled'
import { container, facebookButton, heading2 } from 'app/sofia/resources/theme/css'
import { BREAKPOINT } from 'app/sofia/resources/constants'
import TopBorder from 'resources/svg/community-topborder.svg'
import BottomBorder from 'resources/svg/community-bottomborder.svg'
import Shape from 'resources/svg/community-shape.svg'

export const Container = styled.div`
  padding: 60px 0 30px;
  margin-bottom: 80px;
  position: relative;
  background: ${props => props.theme.palette.primary.alpha};

  &::before {
    content: '';
    width: 100%;
    height: 100px;
    position: absolute;
    background: url(${TopBorder}) no-repeat center bottom;
    background-size: 100vw;
    top: -90px;
    z-index: 2;
    ${bp('sm')`
      top: -99px;
    `}
  }

  &::after {
    content: '';
    width: 100%;
    height: 100px;
    position: absolute;
    background: url(${BottomBorder}) no-repeat center top;
    background-size: 100vw;
    bottom: -90px;
    z-index: 0;
    ${bp('sm')`
      bottom: -99px;
    `}
  }

  > div {
    ${container}
    display: flex;
    justify-content: space-between;
    align-items: center;
    ${bp('sm')`
      flex-direction: column;
    `}

    &::before {
      content: '';
      width: 180px;
      height: 230px;
      position: absolute;
      background: url(${Shape}) no-repeat right top;
      bottom: -80px;
      left: 0;
      z-index: 1;
      ${bp('sm')`
        content: unset;
      `}
    }

    img {
      max-width: 40vw;
      height: auto;
      ${bp('lg')`
        max-width: 50%;
      `}
      @media (max-width: ${BREAKPOINT.MD}) {
        max-width: 35%;
      }

      ${bp('sm')`
        max-width: 100%;
      `}
    }
  }

  h2 {
    ${heading2}
    ${bp('sm')`
      text-align: center;
    `}
  }

  p {
    margin: 10px 0 50px;
    font: ${font('default', 'light', '18px/1.5')};
    ${bp('sm')`
      margin-bottom: 30px;
    `}
  }

  a {
    ${facebookButton}
  }

  .community {
    &__content {
      margin-left: 50px;
      padding: 0 20px;
      max-width: 40%;

      @media (max-width: ${BREAKPOINT.MD}) {
        max-width: 60%;
      }

      ${bp('sm')`
        max-width: unset;
        margin-left: 0;
        padding: 0;
        text-align: center;
      `}
    }
  }
`
